var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('SectionSearchWindow',{on:{"search":_vm.search,"sectionDownload":_vm.sectionDownload}}),_vm._v(" "),_c('SectionSearchResult',{attrs:{"sectionList":_vm.sectionList,"isExistSearchResult":_vm.isExistSearchResult}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a6879e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SectionList.vue
// module id = null
// module chunks = 